import { attr, Model, many } from 'redux-orm';
import generateRandomString from '%app/js/common/services/generateRandomString';
import Translator from '%app/js/common/services/translator';

class Reservation extends Model {
    static modelName = 'Reservation';

    static fields = {
        id: attr(),
        name: attr({ getDefault: () => Translator.trans('seat_selection.reservations.name') }),
        color: attr(),
        cacheKey: attr({ getDefault: () => generateRandomString() }),
        hash: attr({ getDefault: () => generateRandomString() }),
        seats: many('Seat'),
        generalAdmissions: many('GeneralAdmission'),
        capacity: attr({ getDefault: () => 0 }),
    };
}

export default Reservation;
